module.exports = __webpack_public_path__ + "static/media/women-fas-cat-5.0dc3c73b.png";